import React, { useState } from "react";
import { MapPin } from "lucide-react";

const dates = [
  { date: "Sep 11, 2026", city: "Los Angeles, USA", venue: "Riversend Pub", status: "On Sale", sold: false },
  { date: "Sep 12, 2026", city: "Los Angeles, USA", venue: "Norwegian Churches Abroad", status: "On Sale", sold: false },
  { date: "Sep 14, 2026", city: "Los Angeles, USA", venue: "Maui Sugar Mill Saloon — Joe Bonamassa & Jimmy Vivino Support", status: "Featured", sold: false },
  { date: "Sep 16, 2026", city: "Las Vegas, USA", venue: "Sand Dollar", status: "On Sale", sold: false },
  { date: "Sep 19, 2026", city: "Thiensville, USA", venue: "Thiensville Bluesfest", status: "On Sale", sold: false },
  { date: "Sep 25, 2026", city: "San Francisco, USA", venue: "Biscuits and Blues", status: "On Sale", sold: false },
  { date: "Sep 26, 2026", city: "San Francisco, USA", venue: "Norwegian Churches Abroad", status: "On Sale", sold: false },
  { date: "Oct 03, 2026", city: "Las Vegas, USA", venue: "Sand Dollar", status: "On Sale", sold: false },
  { date: "Oct 14, 2026", city: "Las Vegas, USA", venue: "Sand Dollar", status: "On Sale", sold: false },
  { date: "Nov 07, 2026", city: "Las Vegas, USA", venue: "Sand Dollar", status: "On Sale", sold: false },
  { date: "Nov 17, 2026", city: "Las Vegas, USA", venue: "Sand Dollar", status: "On Sale", sold: false },
];

export default function TourDates() {
  const [visible, setVisible] = useState(6);

  return (
    <section
      id="tour"
      data-testid="tour-section"
      className="relative py-14 md:py-20 px-6 md:px-12 bg-vintage-bg"
    >
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-10">
          <div>
            <p className="font-mono text-xs tracking-[0.35em] uppercase text-vintage-rust mb-4">
              / / Live In 2026
            </p>
            <h2 className="font-heading text-5xl md:text-7xl uppercase text-vintage-gold tracking-wide leading-none">
              Tour Dates
            </h2>
          </div>
          <p className="font-subheading italic text-vintage-cream/70 text-lg max-w-md">
            From California to Nevada — catch Otto Junior across the
            States this fall, including the Joe Bonamassa &amp; Jimmy
            Vivino support show on September 14th.
          </p>
        </div>

        {/* Header row */}
        <div className="hidden md:grid grid-cols-12 gap-6 pb-4 border-b border-vintage-cream/15">
          <span className="col-span-2 font-mono text-xs tracking-[0.3em] uppercase text-vintage-cream/50">Date</span>
          <span className="col-span-4 font-mono text-xs tracking-[0.3em] uppercase text-vintage-cream/50">City</span>
          <span className="col-span-4 font-mono text-xs tracking-[0.3em] uppercase text-vintage-cream/50">Venue</span>
          <span className="col-span-2 font-mono text-xs tracking-[0.3em] uppercase text-vintage-cream/50 text-right">Status</span>
        </div>

        {/* Rows */}
        <div data-testid="tour-list">
          {dates.slice(0, visible).map((d, idx) => (
            <div
              key={idx}
              data-testid={`tour-row-${idx}`}
              className="group grid grid-cols-1 md:grid-cols-12 gap-2 md:gap-6 items-center py-6 border-b border-vintage-cream/10 hover:bg-vintage-bg2 transition-colors px-2 md:px-4 -mx-2 md:-mx-4"
            >
              <div className="col-span-2 font-mono text-vintage-rust text-base tracking-wider">
                {d.date}
              </div>
              <div className="col-span-4 font-subheading text-vintage-cream text-2xl flex items-center gap-2">
                <MapPin size={16} className="text-vintage-gold opacity-60" />
                {d.city}
              </div>
              <div className="col-span-4 font-body text-vintage-cream/80 text-lg">
                {d.venue}
              </div>
              <div className="col-span-2 md:text-right">
                <span
                  className={`font-mono text-xs tracking-[0.2em] uppercase px-3 py-1 inline-block ${
                    d.sold
                      ? "bg-vintage-burgundy/30 text-vintage-cream/60 line-through"
                      : d.status === "Featured"
                      ? "bg-vintage-gold/20 text-vintage-gold border border-vintage-gold/40"
                      : d.status === "Few Left"
                      ? "bg-vintage-gold/15 text-vintage-gold"
                      : "bg-vintage-rust/15 text-vintage-rust"
                  }`}
                >
                  {d.status}
                </span>
              </div>
            </div>
          ))}
        </div>

        {visible < dates.length && (
          <div className="text-center mt-12">
            <button
              data-testid="tour-show-more-btn"
              onClick={() => setVisible(dates.length)}
              className="border border-vintage-cream/30 text-vintage-cream font-heading text-lg tracking-[0.2em] px-8 py-3 hover:bg-vintage-cream hover:text-vintage-bg transition-colors uppercase"
            >
              Show All Dates
            </button>
          </div>
        )}
      </div>
    </section>
  );
}
